// extracted by mini-css-extract-plugin
module.exports = {"vars":"'../../vars.css'","secondary":"#C4942F","gray":"#F5F5F5","column":"InfoList-module--column--3PB1N","list":"InfoList-module--list--1I7ld"};